import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  countriesRequest: redukers.request({
    start: actionTypes.COUNTRIES,
    success: actionTypes.COUNTRIES_SUCCESS,
    error: actionTypes.COUNTRIES_ERROR,
  }),
  countries: redukers.value({
    set: actionTypes.SET_COUNTRIES_INFORMATION,
    reset: actionTypes.RESET_COUNTRIES_INFORMATION,
  }),
  isConfigLoaded: redukers.value(
    {
      set: actionTypes.SET_IS_CONFIG_LOADED,
      reset: actionTypes.RESET_IS_CONFIG_LOADED,
    },
    false,
  ),
  CPVRequest: redukers.request({
    start: actionTypes.CPV,
    success: actionTypes.CPV_SUCCESS,
    error: actionTypes.CPV_ERROR,
  }),
  CPV: redukers.value({
    set: actionTypes.SET_CPV_INFORMATION,
    reset: actionTypes.RESET_CPV_INFORMATION,
  }),
  documentsRequest: redukers.request({
    start: actionTypes.DOCUMENTS,
    success: actionTypes.DOCUMENTS_SUCCESS,
    error: actionTypes.DOCUMENTS_ERROR,
  }),
  documents: redukers.value({
    set: actionTypes.SET_DOCUMENTS,
    reset: actionTypes.RESET_DOCUMENTS,
  }),
})
